export function toBRL(value: string | number) {
  if (typeof value === 'string') value = parseFloat(value);

  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

export function toReadableNumber(value: string | number) {
  if (typeof value === 'string') value = parseFloat(value);

  return new Intl.NumberFormat('pt-BR').format(value);
}

export function toReadableDate(date: Date | string) {
  if (typeof date === 'string') date = new Date(date);

  return date.toLocaleDateString('pt-BR');
}

export function toCPF(value: string) {
  value = value.replace(/\D/g, '');
  return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function toCNPJ(value: string) {
  value = value.replace(/\D/g, '');
  return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

export function toDuration(totalInSeconds: number) {
  const hours = Math.floor(totalInSeconds / 3600);
  const minutes = Math.floor((totalInSeconds - hours * 3600) / 60);
  let seconds = Math.floor(totalInSeconds - 3600 * hours - 60 * minutes);

  if (seconds < 10) seconds = '0' + seconds;

  if (!hours) return `${minutes}:${seconds}`;

  return `${hours}:${minutes}:${seconds}`;
}
